import { connect } from 'react-redux';
// selectors
import React from 'react';
import { getOrderTariffInlineTexts } from "../../../store/selectors";
import { ContentHeader } from "../../common/ContentHeader";
var _ShortSuccess = function _ShortSuccess(_ref) {
  var successTexts = _ref.successTexts;
  return /*#__PURE__*/React.createElement(ContentHeader, {
    description: successTexts.description,
    img: successTexts.img,
    title: successTexts.title,
    "data-t-id": "Steps-SuccessFailPopups"
  });
};
var _FailPopup = function _FailPopup(_ref2) {
  var failTexts = _ref2.failTexts;
  return /*#__PURE__*/React.createElement(ContentHeader, {
    description: failTexts.description,
    img: failTexts.img,
    title: failTexts.title
  });
};
var mapStateToProps = function mapStateToProps(state) {
  var _getOrderTariffInline, _getOrderTariffInline2;
  return {
    failTexts: (_getOrderTariffInline = getOrderTariffInlineTexts(state)) === null || _getOrderTariffInline === void 0 ? void 0 : _getOrderTariffInline.failPopupTexts,
    successTexts: (_getOrderTariffInline2 = getOrderTariffInlineTexts(state)) === null || _getOrderTariffInline2 === void 0 ? void 0 : _getOrderTariffInline2.shortSuccessTexts
  };
};
var connector = connect(mapStateToProps);
export var ShortSuccess = connect(mapStateToProps)(_ShortSuccess);
export var Fail = connect(mapStateToProps)(_FailPopup);